import { cn } from '@app/utils/cn';

interface Props {
  label: string | number;
  value: string | number;
  layout?: 'vertical' | 'horizontal' | 'horizontal-reverse';
  valueSize?: 'default' | 'small';
}

export const ProductSummaryItem = ({ label, value, layout = 'horizontal', valueSize = 'default' }: Props) => {
  return (
    <div
      className={cn('flex', {
        'flex-col justify-center sm:justify-end': layout === 'horizontal',
        'flex-col-reverse justify-center': layout === 'horizontal-reverse',
        'flex-row-reverse items-center gap-2': layout === 'vertical',
      })}
    >
      <span className={valueSize === 'default' ? 'heading-3' : 'heading-4'}>{value}</span>
      <div className="uppercase text-neutral-60 heading-4">{label}</div>
    </div>
  );
};
